<template>
  <div class="app-activation-start-wrapper" :class="[showCheckoutView]">
    <SimonModal
      :is-visible="showActivationRetryModal"
      @hide="showActivationRetryModal = false"
      id="activation-retry-modal"
      show-footer-buttons
      @btnLeft="showActivationRetryModal = false"
      @btnRight="retryActivationOk()"
      :btn-left-title="getSlotText('btnPrev', 'Abbrechen')"
      :btn-right-title="getSlotText('btnNext', 'Trotzdem aktivieren')"
    >
      <template v-slot:modalTitle>
        <h2><slot name="headerActivationStartRetryModal">Für diese SIM-Karte wurden bereits persönliche Daten erfasst.</slot></h2>
      </template>
      <div>
        <slot name="txtActivationStartRetryModal">
          <h2>Für diese SIM-Karte wurden bereits<br> persönliche Daten erfasst.</h2>
          <p class="copytext">Wenn du nun nochmals den Aktivierungsprozess startest, werden die bisher hinterlegten
            Daten gelöscht.
            Somit sind die per E-Mail bereitgestellten Links zur Identifikation dann auch nicht mehr gültig.
            Auch eine bereits durchlaufene Identifikation ist ungültig.</p>
        </slot>
      </div>
    </SimonModal>
    <div class="outer-wrapper" v-if="showStep(infoStepName)">
      <div class="bg-box" :class="getSlotText('bgColorBottom').trim()"></div>
      <div class="composition-wrapper" :class="'step-'+ showCheckoutView">
          <slot name="txtBeforeHeadline"></slot>
          <div class="headline-wrapper">
            <slot name="txtHeadline"></slot>
          </div>
          <slot name="txtBeforeCard"></slot>
          <div id="cardsWrapper" class="card-wrapper card">
            <div class=" step info">
              <slot name="txtBeforeInfoStep"></slot>
              <ActivationInfo
                :next-step="selectMnpStepName"
                :retryActivation="retryActivation"
                @web-ident-pending='catchWebIdentPending'
                ref="ActInfo"
              >
                <template v-for="slot in possibleChildSlotsFor('Info')" v-slot:[`${slot.child}`]>
                  <slot :name="`${slot.parent}`"></slot>
                </template>
              </ActivationInfo>
              <slot name="txtAfterCardInfo"></slot>
            </div>
          </div>
      </div>
    </div>
    <div class="step select-mnp" v-else>
      <slot name="txtBeforeCardSelectMnp"></slot>
      <slot name="activationTariffTileHorizontal">TEST</slot>
      <slot name="txtAfterCardSelectMnp"></slot>
    </div>
  </div>
</template>

<script>
import ActivationInfo, { stepName as infoStepName } from '@/components/checkout/activation/PreActivation/Info.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import transaction from '@/mixins/transaction'
import extraData from '@/mixins/extraData'
import processWrapper from '@/mixins/processWrapper'
import { stepName as selectMnpStepName } from '@/components/checkout/tarifftile/ActivationTariffTileHorizontalWrapper.vue'
import SimonModal from '@/components/modal/SimonModal.vue'

export default {
  name: 'ActivationStartWrapper',
  import: {
    infoStepName,
    selectMnpStepName
  },
  data () {
    return {
      activeProcess: 'activation',
      showActivationRetryModal: false,
      retryActivation: false
    }
  },
  created () {
    this.startLoader()
    try {
      if (this.showProcess !== this.activeProcess) {
        this.resetCompleteCheckoutStore()
        this.removePromoCode()
        this.setProcess(this.activeProcess)
        this.setStep(infoStepName)
      }

      if (this.showCheckoutView === 'checkoutMnpIn') {
        this.setStep(selectMnpStepName)
      } else {
        this.setStep(infoStepName)
      }
    } catch (error) {
      console.error('An error occurred:', error)
    } finally {
      this.stopLoader()
    }
  },
  mounted () {
    this.showActivationRetryModal = false
  },
  mixins: [
    transaction('activation'),
    extraData(),
    processWrapper('showCheckoutView')
  ],
  props: {
    availableAboOptions: {
      type: String,
      default: ''
    }
  },
  methods: {
    goToStepBefore (active, step) {
      if (active) {
        this.setStep(step)
      }
    },
    catchWebIdentPending (isPending) {
      // hier kommt die Info aus ActivationInfo, ob schon mal der Aktivierungsprozess durchlaufen worden ist.
      if (isPending === true && this.retryActivation === false) {
        this.showActivationRetryModal = true
      } else {
        this.showActivationRetryModal = false
      }
    },
    retryActivationOk () {
      this.retryActivation = true
      this.showActivationRetryModal = false
      this.$children[1].next(true) // Löst eine erneute Aktivierung in ActivationInfo aus
    },
    ...mapMutations('checkout', [
      'setStep',
      'setProcess'
    ]),
    ...mapActions('checkout', [
      'resetCompleteCheckoutStore'
    ]),
    ...mapActions('promotion/promoCode', [
      'removePromoCode'
    ]),
    ...mapMutations('checkoutv2/activation', {
      setNewStep: 'setStep'
    })
  },
  computed: {
    ...mapGetters('checkout', [
      'showCheckoutView',
      'showProcess'
    ]),
    ...mapGetters('promotion/promoCode', [
      'couponRedeemed',
      'validPromoCode',
      'codePromotions',
      'couponTypeCredit',
      'couponTypeVolume',
      'couponDiscountAmount',
      'couponVolumeAmount',
      'couponVolumeUnit',
      'voucherItem'
    ])
  },
  components: {
    SimonModal,
    ActivationInfo // Achtung, Reihenfolge nicht verändern siehe oben $children[1]
  }
}
</script>
